import { render, staticRenderFns } from "./TrendsView.vue?vue&type=template&id=dec0c748&"
import script from "./TrendsView.vue?vue&type=script&lang=js&"
export * from "./TrendsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports